<div class="doc-section">
    <div class="doc-card" #docCard>
        <style>
            .cl-page {
                font-family: 'Outfit', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
                font-size: 10.5pt;
                font-weight: 400;
                line-height: 1.65;
                color: #000000;
                background: #ffffff;
            }

            .cl-header {
                background-color: #1a2c5b;
                padding: 0 32px;
                height: 52px;
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .cl-brand {
                font-size: 18pt;
                font-weight: 700;
                color: #ffffff;
                line-height: 1;
            }

            .cl-brand-accent {
                color: #f0b429;
            }

            .cl-doc-type-tag {
                background: rgba(255,255,255,0.15);
                border: 1px solid rgba(255,255,255,0.3);
                color: #fff;
                font-size: 8pt;
                font-weight: 600;
                letter-spacing: 1.5px;
                text-transform: uppercase;
                padding: 4px 12px;
                border-radius: 4px;
            }

            .cl-gold-bar {
                height: 4px;
                background: linear-gradient(90deg, #f0b429 0%, #f6d860 50%, #f0b429 100%);
            }

            .cl-body {
                padding: 20px 80px;
                border: none;
            }

            .doc-section, .doc-card, .cl-page {
                border: none;
                box-shadow: none;
            }

            .cl-document-title {
                text-align: center;
                font-weight: 700;
                font-size: 13pt;
                text-transform: uppercase;
                color: #000000;
                letter-spacing: 0.5px;
                margin-bottom: 24px;
                padding-bottom: 12px;
                border-bottom: 2px solid #e8ecf4;
            }

            .cl-recipient-info {
                background: #f7f9fc;
                border: 1px solid #e2e8f0;
                border-left: 4px solid #2a4494;
                border-radius: 6px;
                padding: 14px 18px;
                margin-bottom: 20px;
            }

            .cl-recipient-info p {
                margin-bottom: 4px;
                font-size: 10.5pt;
            }

            .cl-recipient-info p:last-child { 
                margin-bottom: 0; 
            }

            .cl-recipient-info .cl-label {
                font-weight: 600;
                color: #000000;
                min-width: 200px;
                display: inline-block;
            }

            .cl-recipient-info .cl-value {
                font-weight: 700;
                text-transform: capitalize;
                color: #000000;
            }

            .cl-salutation {
                margin-bottom: 14px;
                font-size: 10.5pt;
            }

            .cl-p {
                font-size: 10.5pt;
            }

            .cl-section-heading {
                font-weight: 700;
                font-size: 11pt;
                color: #000000;
                margin-top: 22px;
                margin-bottom: 10px;
                padding-bottom: 4px;
                border-bottom: 1.5px solid #e8ecf4;
                text-transform: uppercase;
                letter-spacing: 0.3px;
            }

            .cl-bold { 
                font-weight: 600; 
            }

            .cl-document-list {
                margin: 14px 0;
            }

            .cl-document-item {
                background: none;
                border: none;
                border-radius: 0;
                padding: 4px 0;
                margin-bottom: 6px;
            }

            .cl-document-item-heading {
                font-weight: 600;
                color: #000000;
                margin-bottom: 8px;
                font-size: 10.5pt;
            }

            .cl-document-item ul {
                margin-left: 14px;
                margin-top: 4px;
                list-style: none;
                padding: 0;
            }

            .cl-document-item ul li {
                margin-bottom: 4px;
                position: relative;
                padding-left: 14px;
                font-size: 10pt;
                color: #000000;
            }

            .cl-document-item ul li::before {
                content: '\203A';
                position: absolute;
                left: 0;
                color: #000000;
                font-weight: 700;
            }

            .cl-what-happens ul {
                list-style: none;
                margin-left: 4px;
                margin-top: 8px;
                padding: 0;
            }

            .cl-what-happens ul li {
                position: relative;
                padding-left: 20px;
                margin-bottom: 6px;
                font-size: 10pt;
                color: #000000;
            }

            .cl-what-happens ul li::before {
                content: '\2713';
                position: absolute;
                left: 0;
                color: #000000;
                font-weight: 700;
                font-size: 11pt;
            }

            .cl-concluding {
                background: #f0f4ff;
                border: 1px solid #c7d4f0;
                border-radius: 6px;
                padding: 12px 16px;
                margin-top: 18px;
                margin-bottom: 14px;
            }

            .cl-concluding p {
                margin-bottom: 4px;
                font-size: 10pt;
                color: #000000;
            }

            .cl-concluding p:last-child { 
                margin-bottom: 0; 
            }

            .cl-closing {
                padding-top: 16px;
                font-size: 10.5pt;
            }

            .cl-sig-block {
                margin-top: 10px;
            }

            .cl-sig-name {
                font-weight: 700;
                font-size: 11pt;
                color: #000000;
            }

            .cl-sig-title {
                font-size: 9.5pt;
                color: #000000;
                margin-top: 2px;
            }

            .cl-footer {
                background-color: #1a2c5b;
                padding: 10px 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 32px;
            }

            .cl-footer span {
                color: rgba(255,255,255,0.6);
                font-size: 8.5pt;
            }
        </style>

        <div class="cl-page">
            <!-- Header -->
            <div class="cl-header">
                <span class="cl-brand">E.A.S.Y. <span class="cl-brand-accent">Liens</span></span>
                <span class="cl-doc-type-tag">Cover Letter</span>
            </div>
            <div class="cl-gold-bar"></div>

            <!-- Body -->
            <div class="cl-body">
                <div class="cl-document-title">Cover Letter &ndash; Medical Lien Resolution Offer</div>

                <!-- Recipient Info -->
                <div class="cl-recipient-info">
                    <p><span class="cl-label">Patient:</span> <span class="cl-value">{{ patientName }}</span></p>
                    <p><span class="cl-label">Provider:</span> <span class="cl-value">{{ providerName }}</span></p>
                    <p><span class="cl-label">Account / Date(s) of Service:</span> <span class="cl-value">{{ accountNumber }} / {{ dateOfService }}</span></p>
                </div>

                <div class="cl-salutation">Dear {{ patientName }} and Counsel,</div>

                <p class="cl-p">
                    E.A.S.Y. Liens is pleased to present the following <span class="cl-bold">medical lien resolution offer</span> for the above-referenced account.
                </p>

                <!-- The Offer -->
                <div class="cl-section-heading">The Offer</div>
                <p class="cl-p">
                    E.A.S.Y. Liens is offering to <span class="cl-bold">pay the Patient</span> an immediate &ldquo;<span class="cl-bold">discount</span>&rdquo; amount of <span class="cl-bold">{{ offerAmount }}</span>, in exchange for the assignment of certain rights related to the provider bill identified above. This allows the Patient to receive funds now, while E.A.S.Y. Liens takes responsibility for resolving the debt and lien with the provider.
                </p>

                <!-- What These Documents Do -->
                <div class="cl-section-heading">What These Documents Do (In Plain Terms)</div>
                <p class="cl-p">
                    Enclosed are <span class="cl-bold">three documents for signature</span>, and one additional document that will be delivered after negotiation is complete:
                </p>

                <div class="cl-document-list">
                    <div class="cl-document-item">
                        <div class="cl-document-item-heading">1. Assignment of Trust Funds, Obligations &amp; Responsibilities</div>
                        <ul>
                            <li>The Patient accepts the above payment.</li>
                            <li>The Patient assigns to E.A.S.Y. Liens the right to resolve and negotiate the medical lien.</li>
                            <li>The funds currently held in the attorney&rsquo;s trust account for this bill are assigned to E.A.S.Y. Liens and delivered once the account is resolved.</li>
                            <li>E.A.S.Y. Liens assumes total responsibility for negotiating with and paying the medical provider, to be accepted as a &ldquo;full and final payment&rdquo; on the account.</li>
                        </ul>
                    </div>

                    <div class="cl-document-item">
                        <div class="cl-document-item-heading">2. Acknowledgment of Assignment (signed by Injury Counsel)</div>
                        <ul>
                            <li>Confirms that the funds for this bill are currently held in trust.</li>
                            <li>Confirms that those funds are not otherwise encumbered.</li>
                            <li>Acknowledges E.A.S.Y. Liens&rsquo; interest in those funds pursuant to the Assignment.</li>
                        </ul>
                    </div>

                    <div class="cl-document-item">
                        <div class="cl-document-item-heading">3. HIPAA Authorization (signed by Patient)</div>
                        <ul>
                            <li>Allows E.A.S.Y. Liens and Walrath Law, P.A. to obtain medical and billing records needed to resolve the lien.</li>
                            <li>This authorization is limited to lien-related purposes only.</li>
                        </ul>
                    </div>

                    <div class="cl-document-item">
                        <div class="cl-document-item-heading">4. Release of Lien and Authority to Distribute (signed by the medical provider)</div>
                        <ul>
                            <li>Obtained by E.A.S.Y. Liens after negotiating the account.</li>
                            <li>Confirms that the account has been resolved and released.</li>
                            <li>Once delivered to Injury Counsel, authorizes release of the trust funds to E.A.S.Y. Liens.</li>
                        </ul>
                    </div>
                </div>

                <!-- What Happens After Signing -->
                <div class="cl-section-heading">What Happens After Signing</div>
                <div class="cl-what-happens">
                    <ul>
                        <li>Patient receives the agreed payment from E.A.S.Y. Liens.</li>
                        <li>E.A.S.Y. Liens and its attorneys negotiate directly with the medical provider.</li>
                        <li>The medical provider signs a Release of Lien and Authority to Distribute.</li>
                        <li>Injury Counsel receives the Release of Lien and releases the trust funds.</li>
                        <li>The matter is concluded with no further action required.</li>
                    </ul>
                </div>

                <!-- Concluding Statements -->
                <div class="cl-concluding">
                    <p>This process is ethically compliant, as all funds are held in Trust until lien is released.</p>
                    <p>E.A.S.Y. Liens, LLC, as Assignee, does <span class="cl-bold">not</span> represent the Patient or Injury Attorney.</p>
                </div>

                <!-- Closing -->
                <div class="cl-closing">
                    <p class="cl-p">Sincerely,</p>
                    <div class="cl-sig-block">
                        <div class="cl-sig-name">E.A.S.Y. Liens, LLC</div>
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="cl-footer">
                <span>E.A.S.Y. Liens, LLC &mdash; Confidential</span>
            </div>
        </div>
    </div>

</div>
